// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2EHu4","inner":"Footer_inner__3JtHH"};